import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { useLoader } from "../ViewHooks/LoaderHook"; // Importando o novo hook de loader
import { ApiLogin } from "../Utils/ApiLogin";
import { api_login_unico_url, login_unico_app } from "../Utils/Urls";
import { useResponse } from "../ViewHooks/Response";

const UsuarioContext = createContext({} as ContextData);
const chave_localStorage = "@login-unico";
interface ContextData {
  usuario: IUsuario;
  logar: (
    usuario: string,
    senha: string,
    tipo?: "id" | "cpf" | "usuario"
  ) => Promise<void>;
  sair: () => void;
  token: string;
  checarToken: () => Promise<void>;
}

function useUsuario() {
  const context = useContext(UsuarioContext);
  if (!context) {
    throw new Error("useUsuario deve ser usado dentro de um UsuarioProvider");
  }
  return context;
}

interface IProviderProps {
  children: ReactNode;
}

export interface IUsuario {
  usuario: {
    id: number;
    entidade_id: number;
    usuario: string;
    senha: string;
    cpf: string;
    administrador: boolean;
    email: string;
    inativo: boolean;
    nome: string;
    foto: string;
    telefone: string;
  };
  entidade: {
    id: number;
    titulo: string;
    banco: string;
    logo: string;
    apresentacao: string;
    portal: string;
    site: string;
    site2: string;
    pasta: string;
  };
  sistemas: ISistema[];
}

function UsuarioProvider({ children }: IProviderProps) {
  const [usuario, setUsuario] = useState({} as IUsuario);
  const [token, setToken] = useState("");
  //setMensagem, setPorcentagem,
  const { showLoader, hideLoader, teste } = useLoader(); // Usando o hook de loader

  const chave_localStorage = "@login-unico";
  const { addResponse } = useResponse();
  async function logar(
    usuario: string,
    senha: string,
    tipo: "id" | "cpf" | "usuario" = "usuario"
  ) {
    // setMensagem("Efetuando login...");
    // setPorcentagem(10);

    //showLoader("Efetuando login...", 10);

    try {
      const { data } = await ApiLogin.post(`/login-completo`, {
        usuario,
        senha,
        tipo,
      });

      //showLoader("Efetuando login...", 50);

      if (data.status) {
        const usuarioData = data.data.login.usuario;
        usuarioData.foto =
          usuarioData.foto && usuarioData.foto.length > 0
            ? api_login_unico_url + "/foto-de-perfil/" + usuarioData.foto
            : null;

        setUsuario(data.data.login);
        setToken(data.data.token);
        //showLoader("Efetuando login...", 100);
      }
    } catch (e) {
      console.error(e); // Manter o erro no console para debug
    } finally {
      hideLoader(); // Limpa a mensagem após o login
    }
  }

  async function checarToken() {
    // setPorcentagem(10);
    //showLoader("Efetuando login...", 10);
    try {
      const { data } = await ApiLogin.get(`/checar-token`);
      // setPorcentagem(50);
      //showLoader("Efetuando login...", 50);
      const usuarioData = data.usuario.usuario;
      usuarioData.foto =
        usuarioData.foto && usuarioData.foto.length > 0
          ? api_login_unico_url + "/foto-de-perfil/" + usuarioData.foto
          : null;

      setUsuario((PREV) => data.usuario);
    } catch (e) {
      console.error(e); // Manter o erro no console para debug
    }
  }

  function sair() {
    localStorage.removeItem(chave_localStorage);
    setUsuario({} as IUsuario);
    setToken("");
  }

  useEffect(() => {
    if (token) {
      localStorage.setItem(chave_localStorage, token);
      ApiLogin.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }, [usuario, token]);

  useEffect(() => {
    if (usuario && usuario.usuario && usuario.usuario.id)
      addResponse("Seja bem vindo " + usuario.usuario.nome, "success");
  }, [usuario]);

  useEffect(() => {}, []);

  useEffect(() => {
    const token = localStorage.getItem(chave_localStorage);
    ApiLogin.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setToken(token ? token : "");
    //checarToken();
  }, []);

  return (
    <UsuarioContext.Provider
      value={{ usuario, logar, sair, token, checarToken }}
    >
      {children}
    </UsuarioContext.Provider>
  );
}

export { UsuarioProvider, useUsuario };

export interface ISistema {
  id: number;
  titulo: string;
  url: string;
  usuario_id: number;
  sistema_id: number;
  logo: string;
  descricao: string;
}
